import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type ConfirmDialogProps = {
  open: boolean
  title: string
  description?: ReactNode

  confirmText?: string
  cancelText?: string

  /** destructive 会使用 destructive 按钮样式 */
  destructive?: boolean

  /** 异步操作中：禁用按钮并显示处理中 */
  loading?: boolean

  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({
  open,
  title,
  description,

  confirmText = '确认',
  cancelText = '取消',

  destructive = false,
  loading = false,

  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className='w-[420px] max-w-[calc(100%-2rem)] p-0'>
        <div className='p-6'>
          <DialogHeader className='space-y-1'>
            <DialogTitle className='text-base font-medium'>{title}</DialogTitle>
          </DialogHeader>

          {description ? (
            <div className='text-muted-foreground mt-2 text-sm leading-relaxed'>
              {description}
            </div>
          ) : null}

          <div className='mt-6 flex justify-end gap-2'>
            <Button
              type='button'
              variant='outline'
              disabled={loading}
              onClick={onCancel}
            >
              {cancelText}
            </Button>

            <Button
              type='button'
              variant={destructive ? 'destructive' : 'default'}
              disabled={loading}
              onClick={onConfirm}
            >
              {loading ? '处理中…' : confirmText}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
